import React from "react";
import PropTypes from "prop-types";
import { THEMES } from "common/constants/Constants";
import styles from "./styles.module.scss";

const ErrorMessage = ({ error: { message } = {}, theme = THEMES.ERROR_THEME_MODULE_LEVEL }) => {
    if (!message) {
        return null;
    }

    const className = `${ styles.error } ${ styles[theme] }`;

    return (
        <div className={ className } id="form-element-error-message" dangerouslySetInnerHTML={ { __html: message } } />
    );
};

ErrorMessage.propTypes = {
    error: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string.isRequired
    }),
    theme: PropTypes.string
};

export default ErrorMessage;
